import { z } from 'zod';
import { WireSizingSchema } from '../validators/WireSizing';

export type WireSizing = z.infer<typeof WireSizingSchema>;

export enum WireSizingStandard {
    IEC = 'IEC',
    NEC = 'NEC',
}

export const WireSizingStandardOptions = Object.values(WireSizingStandard).map((value) => ({
    value,
    label: value,
}));
